import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c18fe17")

_pushScopeId("data-v-2c18fe17")
const _hoisted_1 = { class: "page__header df-middle" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "flex-3 t-center f-bold f-lg _p-title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Title")
const _hoisted_5 = { class: "flex-1 t-right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (!_ctx.noLeft)
        ? _renderSlot(_ctx.$slots, "left", { key: 0 }, undefined, true)
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_3, [
      (!_ctx.noTitle)
        ? _renderSlot(_ctx.$slots, "title", { key: 0 }, () => [
            _hoisted_4
          ], {}, true)
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_5, [
      (!_ctx.noRight)
        ? _renderSlot(_ctx.$slots, "right", { key: 0 }, () => [
            _createVNode(_component_Icon, {
              name: "close",
              class: "c-title anchor",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
            })
          ], {}, true)
        : _createCommentVNode("", true)
    ])
  ]))
})